import React, {useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import DatePicker from 'react-datepicker'
import Select from 'react-select'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {startLoadding} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {GetFilterContactSegment, UpdateData, DeleteData} from '../SegmentSlice/SegmentSlice'
import {useDispatch, useSelector} from 'react-redux'
import ReactPaginate from 'react-paginate'
import moment from 'moment-timezone'
import {getalltagsdata} from '../../Tags/TagSlice/TagsSlices'

const ViewSegmentPopup = ({
  show,
  handleClose,
  segmentData,
  setSegmentData,
  setNewSegmentData,
  newSegmentData,
  handleOpenCreate,
}: any) => {
  const ConditionOptions: any = {
    tags: [
      {value: '', label: 'Select'},
      {value: '$in', label: `Is tagged`},
      {value: '$nin', label: `Is not tagged`},
    ],
    Birthday: [
      {value: '', label: 'Select'},
      {value: '$in', label: `is`},
      {value: '$nin', label: `is not`},
      {value: '$in', label: `is in between`},
    ],
    Address: [
      {value: '', label: 'Select'},
      {value: '$eq', label: `contains`},
      {value: '$ne', label: `does not contain`},
    ],
    'Postal Code': [
      {value: '', label: 'Select'},
      {value: '$in', label: `is`},
      {value: '$nin', label: `is not`},
      {value: '$in', label: `is in between`},
    ],
    Postalcode: [
      {value: '', label: 'Select'},
      {value: '$in', label: `is`},
      {value: '$nin', label: `is not`},
      {value: '$in', label: `is in between`},
    ],
    createdAt: [
      {value: '', label: 'Select'},
      {value: '$in', label: `is`},
      {value: '$nin', label: `is not`},
      {value: '$in', label: `is in between`},
    ],
    'First Name': [
      {value: '', label: 'Select'},
      {value: '$eq', label: `contains`},
      {value: '$ne', label: `does not contain`},
    ],
    'Last Name': [
      {value: '', label: 'Select'},
      {value: '$eq', label: `contains`},
      {value: '$ne', label: `does not contain`},
    ],
    addedThrough: [
      {value: '', label: 'Select'},
      {value: '$eq', label: `was`},
      {value: '$ne', label: `was not`},
    ],
    bounced: [
      {value: '', label: 'Select'},
      {value: '$eq', label: `is`},
      {value: '$in', label: `has in between`},
    ],
    click: [
      {value: '', label: 'Select'},
      {value: '$gte', label: `Equal to or Greater than`},
      {value: '$lt', label: `Equal to or Less than`},
    ],
    clickedAt: [
      {value: '', label: 'Select'},
      {value: '$in', label: `is`},
      {value: '$nin', label: `is not`},
      {value: '$in', label: `is in between`},
    ],
  }

  const SelectorOption: any = [
    {value: 'tags', label: 'Tags'},
    {value: 'createdAt', label: 'Join date'},
    {value: 'addedThrough', label: 'Sign up source'},
    {value: 'Birthday', label: 'Birthday'},
    {value: 'Postal Code', label: 'Postal Code'},
    {value: 'Postalcode', label: 'Postal Code'},
    {value: 'First Name', label: 'First Name'},
    {value: 'Last Name', label: 'Last Name'},
    {value: 'Address', label: 'Address'},
    {value: 'bounced', label: 'Bounced'},
    {value: 'click', label: 'Click (CT)'},
    {value: 'clickedAt', label: 'Time & Date Range of (CT)'},
  ]
  const [page, setPage] = useState({
    page: 1,
    size: 10,
  })
  const tagslist = useSelector((state: any) => state?.tags?.allTags?.data)
  const dbOptions: any[] = useSelector(
    (state: any) => state?.subscriberData?.FieldName?.data?.fields
  )
  const segmentContact = useSelector((state: any) => state?.SegmentData?.segmentContact?.data)
  const dispatch = useDispatch()
  ///// relation between conditions
  const [AndOr, setAndOr] = useState<any>({relation1: '$or-1', relation2: '$or-2'})
  ////Condition array
  const [addCondition, setAddCondition] = useState<any>([
    {
      selector: {value: '', label: 'Select'},
      relation: {value: '', label: 'Select'},
      condition: '',
      conditionType: '',
    },
  ])

  useEffect(() => {
    dispatch(getalltagsdata())
  }, [])

  useEffect(() => {
    dispatch(startLoadding())
    dispatch(GetFilterContactSegment({id: newSegmentData?._id, page: page}))
  }, [page.page, page.size])

  useEffect(() => {
    if (newSegmentData?._id !== undefined) {
      let conditions = [
        newSegmentData?.condition1,
        newSegmentData?.condition2,
        newSegmentData?.condition3,
      ]?.filter((key: any) => key !== undefined)
      var finalArr = [...conditions]
      conditions?.map((key: any, index: number) => {
        var arr: any = []
        if (key?.selector == 'tags') {
          let option = tagslist?.map((val: any) => {
            key?.condition?.forEach(
              (key2: any) => key2 === val?._id && arr?.push({value: val?._id, label: val?.name})
            )
          })
          let val: any = {...finalArr[index]}

          //////////////////////////COndition set
          val[`condition`] = arr
          val['selector'] = SelectorOption?.find((val: any) => val?.value == key?.selector)
          val['relation'] = ConditionOptions?.[key?.selector]?.find(
            (val: any) => val?.value == key?.relation
          )
          finalArr.splice(index, 1)
          finalArr.splice(index, 0, val)
        }
        if (['createdAt', 'BirthDay', 'clickedAt'].includes(key?.selector)) {
          let val: any = {...finalArr[index]}
          let date = key?.condition?.split('||')
          let date1 = date?.[0]?.replaceAll('/', '-')

          val['selector'] = SelectorOption?.find((val: any) => val?.value == key?.selector)
          val['relation'] = ConditionOptions?.[key?.selector]?.find((val: any) =>
            date?.[0] !== date?.[1] ? val?.label == 'is in between' : val?.value == key?.relation
          )
          val['condition'] = {
            start: new Date(date?.[0]?.replaceAll('/', '-')),
            end: new Date(date?.[1]?.replaceAll('/', '-')),
          }

          finalArr.splice(index, 1)
          finalArr.splice(index, 0, val)
        }
        if (['Postal Code', 'Postalcode', 'bounced'].includes(key?.selector)) {
          let val: any = {...finalArr[index]}
          let data = key?.condition?.split('||')
          let relationOption =
            key?.relation == '$in' ? `Is ${key?.selector}` : `Not ${key?.selector}`
          val['selector'] = SelectorOption?.find((val: any) => val?.value == key?.selector)
          val['relation'] = ConditionOptions?.[key?.selector]?.find((val: any) =>
            data?.[0] !== data?.[1]
              ? val?.label?.includes('in between')
              : val?.value == key?.relation
          )
          val['condition'] = {
            start: data[0],
            end: data[1],
          }

          finalArr.splice(index, 1)
          finalArr.splice(index, 0, val)
        }
        if (['First Name', 'Last Name'].includes(key?.selector)) {
          let val: any = {...finalArr[index]}
          let relationOption =
            key?.relation == '$in' ? `Is ${key?.selector}` : `Not ${key?.selector}`
          val['selector'] = SelectorOption?.find((val: any) => val?.value == key?.selector)
          val['relation'] = ConditionOptions?.[key?.selector]?.find(
            (val: any) => val?.value == key?.relation
          )
          val['condition'] = key?.condition

          finalArr.splice(index, 1)
          finalArr.splice(index, 0, val)
        }
        if (key?.selector == 'Address') {
          let val: any = {...finalArr[index]}

          val['selector'] = SelectorOption?.find((val: any) => val?.value == key?.selector)
          val['relation'] = ConditionOptions?.[key?.selector]?.find(
            (val: any) => val?.value == key?.relation
          )
          val['condition'] = key?.condition

          finalArr.splice(index, 1)
          finalArr.splice(index, 0, val)
        }
        if (key?.selector == 'addedThrough') {
          let val: any = {...finalArr[index]}
          // let relationOption =
          // key?.relation == '$eq' ? : `Not ${key?.selector}`
          val['selector'] = SelectorOption?.find((val: any) => val?.value == key?.selector)
          val['relation'] = ConditionOptions?.[key?.selector]?.find(
            (val: any) => val?.value == key?.relation
          )
          val['condition'] = {value: key?.condition, label: key?.condition?.toUpperCase()}

          finalArr.splice(index, 1)
          finalArr.splice(index, 0, val)
        }
      })

      setAndOr({
        relation1: `${newSegmentData?.relation1 || '$or'}-1`,
        relation2: `${newSegmentData?.relation2 || '$or'}-2`,
      })
      setAddCondition(finalArr)
    }
  }, [newSegmentData])

  const checkField = () => {
    let fields = ['First Name', 'Full Name', 'Last Name']
    if (dbOptions?.find((val: any) => fields.includes(val)) == undefined) {
      return false
    } else {
      return true
    }
  }

  const handleSubmit = () => {
    let orAndCondition = {...AndOr}

    let finaldata: any = {
      name: newSegmentData?.name,
    }
    if (addCondition?.length > 1) {
      finaldata.relation1 = AndOr?.relation1?.split('-')[0]
    }
    if (addCondition?.length > 2) {
      finaldata.relation1 = AndOr?.relation1?.split('-')[0]
      finaldata.relation2 = AndOr?.relation2?.split('-')[0]
    }

    let x = addCondition?.map((key: any, keyIndex: number) => {
      if (key?.selector?.value == 'tags') {
        let ids = key?.condition?.length > 0 ? key?.condition?.map((val: any) => val?.value) : []
        return {
          ...key,
          condition: ids,
          relation: key?.relation?.value,
          selector: key?.selector?.value,
        }
      }
      if (['createdAt', 'Birthday', 'clickedAt'].includes(key?.selector?.value)) {
        var Startdate = new Date(key?.condition?.start)

        // Get the year, month, and day components
        var startyear = Startdate.getFullYear()
        var startmonth = (Startdate.getMonth() + 1).toString().padStart(2, '0') // Month is zero-based, so we add 1
        var startday = Startdate.getDate().toString().padStart(2, '0')
        var enddate = new Date(key?.condition?.end || key?.condition?.start)

        // Get the year, month, and day components
        var endyear = enddate.getFullYear()
        var endmonth = (enddate.getMonth() + 1).toString().padStart(2, '0') // Month is zero-based, so we add 1
        var endday = enddate.getDate().toString().padStart(2, '0')

        return {
          ...key,
          condition: `${startyear}/${startmonth}/${startday}||${endyear}/${endmonth}/${endday}`,
          relation: key?.relation?.value,
          selector: key?.selector?.value,
        }
      }
      if (['Postal Code', 'Postalcode', 'bounced'].includes(key?.selector?.value)) {
        return {
          ...key,
          condition: `${key?.condition?.start || key?.condition?.start}||${
            key?.condition?.end || key?.condition?.start
          }`,
          relation: key?.relation?.value,
          selector: key?.selector?.value,
        }
      }
      if (['First Name', 'Last Name', 'Address', 'click'].includes(key?.selector?.value)) {
        return {
          ...key,
          condition: `${key?.condition}`,
          relation: key?.relation?.value,
          selector: key?.selector?.value,
        }
      }
      if (key?.selector?.value == 'addedThrough') {
        return {
          ...key,
          condition: `${key?.condition?.value}`,
          relation: key?.relation?.value,
          selector: key?.selector?.value,
        }
      }
      if (key?.selector?.value == '') {
        return {...key, relation: key?.relation?.value, selector: key?.selector?.value}
      }
    })

    let asd = {...finaldata}
    x?.map((key: any, index: any) => {
      asd[`condition${index + 1}`] = key
    })

    if (newSegmentData?._id !== undefined) {
      if (!newSegmentData?.isReviewed) {
        asd = {...asd, isReviewed: true}
      }
      dispatch(UpdateData({data: asd, id: newSegmentData?._id}))

      setAndOr({relation1: '', relation2: ''})
      setAddCondition([
        {
          selector: {value: '', label: 'Select'},
          relation: {value: '', label: 'Select'},
          condition: '',
          conditionType: '',
        },
      ])
      setSegmentData({})
    }
    handleClose()
  }

  const handleCancel = async () => {
    dispatch(
      DeleteData({
        segmentIds: [newSegmentData?._id],
      })
    ).then(() => {
      handleClose()
      setSegmentData({})
    })
  }

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-950px'
        className='vh-100'
        show={show}
        backdrop='static'
        onHide={handleClose}
      >
        <div className='modal-header'>
          <h2>Review your segment</h2>
          <div className='btn btn-icon btn-sm' onClick={handleCancel}>
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body p-10 pt-5'>
          <div className='view-segment-conataienr'>
            <div className='view-segment-box'>
              <div className='first'>{newSegmentData?.name}</div>
              <div className='second'>Name</div>
            </div>
            <div className='view-segment-box'>
              <div className='first'>{segmentContact?.total}</div>
              <div className='second'>Contacts is segment</div>
            </div>
            {/* <div className='view-segment-box'>
              <div className='first'>{'Tags > is tagged > Active clients'}</div>
              <div className='second'>Conditions</div>
            </div> */}
          </div>

          <div className='card-body pt-2'>
            <div className='tab-content'>
              <div
                className='table-responsive'
                style={{msOverflowStyle: 'none', scrollbarWidth: 'none'}}
              >
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold text-muted text-uppercase'>
                      <th>Mobile</th>
                      <th>Tags</th>
                      <th>Status</th>
                      {checkField() && dbOptions?.includes('First Name') && <th>First Name</th>}
                      {checkField() && dbOptions?.includes('Last Name') && <th>Last Name</th>}
                      {checkField() && dbOptions?.includes('Full Name') && <th>Full Name</th>}

                      {dbOptions?.map((val: any, i: number) => {
                        if (!['First Name', 'Full Name', 'Last Name']?.includes(val)) {
                          return <th key={i}>{val}</th>
                        }
                      })}

                      <th>Date Added</th>
                    </tr>
                  </thead>
                  <tbody className='text-gray-600'>
                    {segmentContact?.items?.map((val: any, i: number) => (
                      <tr key={i}>
                        <td>
                          <b>{val?.number}</b>
                        </td>
                        <td
                          data-bs-toggle='tooltip'
                          data-bs-placement='top'
                          title={val?.tags
                            ?.filter((key: any) => key?.isHidden === false)
                            ?.map((key: any) => key?.name)
                            .join()}
                        >
                          <span
                            className='d-inline-block text-truncate'
                            style={{maxWidth: '120px'}}
                          >
                            {val?.tags
                              ?.filter((key: any) => key?.isHidden === false)
                              ?.map((key: any) => key?.name)
                              .join()}
                          </span>
                        </td>
                        <td>
                          {val?.contact?.isBlockedByUser || val?.contact?.isBlocked
                            ? 'Unsubscribed'
                            : 'Subscribed'}
                        </td>
                        {dbOptions?.includes('First Name') &&
                          (val?.fields?.findIndex((val: any) => val?.name === 'First Name') !==
                          -1 ? (
                            <td>
                              {
                                val?.fields?.[
                                  val?.fields?.findIndex((val: any) => val?.name === 'First Name')
                                ]?.value
                              }
                            </td>
                          ) : (
                            <td>-</td>
                          ))}
                        {dbOptions?.includes('Last Name') &&
                          (val?.fields?.findIndex((val: any) => val?.name === 'Last Name') !==
                          -1 ? (
                            <td>
                              {
                                val?.fields?.[
                                  val?.fields?.findIndex((val: any) => val?.name === 'Last Name')
                                ]?.value
                              }
                            </td>
                          ) : (
                            <td>-</td>
                          ))}
                        {dbOptions?.includes('Full Name') &&
                          (val?.fields?.findIndex((val: any) => val?.name === 'Full Name') !==
                          -1 ? (
                            <td>
                              {
                                val?.fields?.[
                                  val?.fields?.findIndex((val: any) => val?.name === 'Full Name')
                                ]?.value
                              }
                            </td>
                          ) : (
                            <td>-</td>
                          ))}

                        {dbOptions?.map((Fields: any, i: number) => {
                          let check = val?.fields?.map((key: any) => key?.name)
                          if (!['First Name', 'Full Name', 'Last Name']?.includes(Fields)) {
                            if (check?.includes(Fields)) {
                              return (
                                <td key={i}>
                                  {val?.fields?.find((key: any) => key?.name == Fields)?.value}
                                </td>
                              )
                            } else {
                              return <td key={i}>--</td>
                            }
                          }
                        })}

                        <td>{moment(val?.createdAt).format('DD/MM/YYYY')}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className='abcd '>
                  <select onChange={(e: any) => setPage({...page, size: e.target.value, page: 1})}>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={250}>250</option>
                  </select>
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={segmentContact?.totalPages}
                    onPageChange={(e: any) => setPage({...page, page: e.selected + 1})}
                    containerClassName={'pagiantion'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className='d-flex justify-content-end mt-10'>
            <button
              type='submit'
              onClick={handleCancel}
              className='btn btn-sm gray_bg_purple me-2 w-100px p-3 fw-500 me-2'
            >
              <span className='indicator-label'>Cancel</span>
            </button>
            <div
              id='kt_drawer_chat_close'
              onClick={() => {
                setSegmentData({...newSegmentData, isNotCreate: true})
                handleClose()
                handleOpenCreate()
              }}
            >
              <button type='button' className='btn btn-sm gray_bg_purple me-2 w-100px p-3 fw-500'>
                Edit segment
              </button>
            </div>

            <button
              type='submit'
              onClick={handleSubmit}
              className='btn btn-sm btn-light btn-primary fw-500 p-3 px-7 border border-primary'
            >
              <span className='indicator-label'>Create segment</span>
            </button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default ViewSegmentPopup
